import { Global, Collection, Jobs } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "../../components/SeoHead";
import LatestAwards from "../../components/LatestAwards";
import LatestNews from "../../components/LatestNews";
import MainBanner from "../../components/MainBanner";
import LatestJobs from "../../components/LatestJobs";
import ImageWithVideoBanner from "../../components/ImageWithVideoBanner";
import MultiColumnCTA from "../../components/MultiColumnCTA";
import ImageWithTextWithOverlay from "../../components/ImageWithTextWithOverlay";
import GreatRecruitersWidget from "components/GreatRecruitersWidget";

export default function Home({
  global,
  all_awards,
  all_news,
  all_jobs,
  all_solutions,
  all_sectors,
}) {
  return (
    <>
      <SeoHead
        site_name={`SRG | United States`}
        page_name={`Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG | United States`}
        en_gb={false}
        en_us={true}
      />
      <MainBanner
        global={global}
        pathPrefix={`us.homepage.main_banner`}
        customClass={``}
        content={
          <>
            <h1>
              We are the house of global<br></br> tech recruitment
            </h1>
            <p>
              Lorien is a digital, transformation and technology recruitment
              specialist. We work with clients of all sectors, sizes, and tech
              needs–from digital giants to tech-enabled businesses–to attract
              and retain top talent around the world. Through our network of
              specialists, we combine deep tech sector expertise with the scope,
              depth, and breadth of large-scale talent solutions, giving our
              clients the confidence and the agility to compete in the digital
              age.
            </p>
          </>
        }
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Science lab workers looking at test tube`}
        imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
        imageALT2={`Overlay Main Banner`}
        jobSearch={true}
        pageAnchor={`more-info-of-us`}
        locale={`/us`}
        h1_content={
          <>
            Industry Leaders in <br></br>Life Sciences Recruitment
          </>
        }
      />
      <ImageWithTextWithOverlay
        global={global}
        pathPrefix={`us.salary_survey_page.image_with_text_with_overlay`}
        customClass={`py-5 `}
        backgroundColor={"#ffffff"}
        content={
          <>
            <h2>Ask David</h2>
            <p>At Lorien, we put people first. Building trust through genuine, honest relationships is one of our core values and underpins everything we do. Ask David is all about resolving problems quickly, helpfully and at the source.</p>
            <p>As a concept, it’s simple: if you’re a current contractor at Lorien with a question, concern or request, then get in touch using the below contact form and David will respond directly to you himself within 24 hours. With more than 20 years’ experience in recruitment at all levels and operations, David can provide expert guidance and support on almost any recruitment-related subject (and if he can’t, he’ll put you in touch with someone who can).</p>
          </>
        }
        buttonTitle={`Download Now`}
        buttonLink={`/us/salary-survey/`}
        buttonNewTab={false}
        imageURL={`/site-assets/images/us-global.png`}
        imageALT={`Job Seekers Featured Image`}
        popUpModal_1={false}
      />
      <ImageWithVideoBanner
        global={global}
        pathPrefix={`us.homepage.image_with_video_banner`}
        customClass={`py-5`}
        content={
          <>
            <h2>It's What We Do</h2>
          </>
        }
        buttonTitle={`Learn More About What We Do`}
        buttonLink={`/`}
        videoLink={`https://www.youtube.com/watch?v=_x5yLlZW1Hg`}
        bannerImage={``}
        imageURL={`/site-assets/images/what-we-do.png`}
        imageALT={`It's what we do`}
        videoGalleryClass={`WhatWeDo`}
        sectionId={`what-we-do`}
        pageAnchor={`more-info-of-us`}
      />
      <LatestJobs
        global={global}
        pathPrefix={`us.homepage.latest_jobs`}
        customClass={`py-5`}
        post={all_jobs}
        content={
          <>
            <h2>Hot Jobs</h2>
            <p>Find the best tech and digital career opportunities.</p>
          </>
        }
        buttonTitle={`View All Jobs`}
        buttonLink={`/us/jobs/`}
        swiperID={`latestJobsSwiper`}
        locale={`/us`}
      />

      <MultiColumnCTA
        global={global}
        pathPrefix={`us.homepage.multi_column_cta`}
        customClass={`py-5`}
        sectionId={`more-info-of-us`}
        left_content={
          <>
            <h2>Market's We Recruit</h2>
          </>
        }
        right_content={
          <>
            <h2>Business Solutions</h2>
          </>
        }
        left_post={all_sectors}
        right_post={all_solutions}
        leftColumnFilterUrl={`us/sectors/`}
      />

      <LatestNews
        global={global}
        pathPrefix={`us.homepage.latest_news`}
        customClass={`py-5`}
        post={all_news}
        content={
          <>
            <h2>The Lorien Pulse: Latest News, Events, and Insights</h2>
            <p>
              Our tech expertise and partner-led approach allows us to deliver
              highly successful results for our clients so they can attract and
              retain unique talent for their business. Explore our latest
              collection of case studies, news, events, and insights
            </p>
          </>
        }
        buttonLink={`/us/blog/`}
        buttonTitle={`View All Insights`}
        locale={`us/`}
      />
      <LatestAwards
        global={global}
        pathPrefix={`us.homepage.latest_awards`}
        customClass={`pt-5`}
        content={
          <>
            <h2>Awards & Industry Recognition</h2>
          </>
        }
        post={all_awards}
        buttonLink={``}
        buttonTitle={``}
        swiperID={`latestAwardsSwiper`}
      />
      <GreatRecruitersWidget />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const awards = await Collection("awards_industry_recognition");
  const solutions = await Collection("solutions_us");
  const sectors = await Collection("sectors_us");

  const news = (await Collection("news")).filter(function (post) {
    return post.country?.en == "United States" || post.country?.en == "All";
  });

  const all_jobs = (await Jobs())
    .filter(function (job) {
      return (
        job.categories
          // Pulls Sectors only
          .find(
            (cat) =>
              cat.id === "b4b8be3c-ba95-4912-aa85-2cbc1264449d" &&
              cat.values.find((x) => x.name === "United States")
          )
      );
    })
    .filter(function (job) {
      return new Date(job?.expires_at) >= new Date();
    })
    .getItems()
    .slice(0, 8);
  const all_solutions = solutions.orderBy("order").getItems();
  const all_sectors = sectors.orderBy("order").getItems();
  const all_awards = awards.orderBy("order").getItems();
  const all_news = news.orderBy("date").getItems().slice(0, 8);

  return {
    props: {
      global,
      all_awards,
      all_news,
      all_jobs,
      all_solutions,
      all_sectors,
    },
  };
}
